/**
 * @generated SignedSource<<58ad71540e338045ee4b40e77d56d3af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MigrateListConfigClickListener_JiraView$data = {
  readonly id: string;
  readonly savedViewId?: string | null | undefined;
  readonly " $fragmentType": "MigrateListConfigClickListener_JiraView";
};
export type MigrateListConfigClickListener_JiraView$key = {
  readonly " $data"?: MigrateListConfigClickListener_JiraView$data;
  readonly " $fragmentSpreads": FragmentRefs<"MigrateListConfigClickListener_JiraView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "MigrateListConfigClickListener_JiraView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesdogfoodingenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "savedViewId"
        }
      ]
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "c3022818b38023a0d272c92fd53aecc3";

export default node;
